module.exports = __webpack_public_path__ + "img/loader.76ad6213.svg";